import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";

export const ModalValorConstante = (props) => {
  let op = require("../../../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  const txtValor = useRef(null);
  const [operacion, setOperacion] = useState(props.operacion || 2); // 2=editar, 4=consultar
  const [errores, setErrores] = useState({});

  useEffect(() => {
    if (props.datos) {
      llenarCampos(props.datos);
    }

    if (operacion === 4) {
      deshabilitarCampos();
    } else if (operacion === 2) {
      habilitarCampos();
      txtValor.current?.focus();
    }
  }, [props.datos, props.operacion]);

  const llenarCampos = (datos) => {
    if (txtValor.current && datos.valor !== undefined) {
      txtValor.current.value = formatearMonto(datos.valor);
    }
  };

  const formatearMonto = (valor) => {
    if (valor === null || valor === undefined) return "0,00";
    const numero = typeof valor === 'string' ? parseFloat(valor) : valor;
    return numero.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const deshabilitarCampos = () => {
    if (txtValor.current) txtValor.current.disabled = true;
  };

  const habilitarCampos = () => {
    if (txtValor.current) txtValor.current.disabled = false;
  };

  const validarCampos = () => {
    const nuevosErrores = {};
    let valido = true;

    if (!txtValor.current?.value) {
      nuevosErrores.valor = "El valor no debe estar en blanco";
      valido = false;
    } else {
      const valor = txtValor.current.value.replace(/\./g, '').replace(',', '.');
      if (isNaN(parseFloat(valor))) {
        nuevosErrores.valor = "El valor debe ser un número válido";
        valido = false;
      }
    }

    setErrores(nuevosErrores);
    return valido;
  };

  const aceptar = () => {
    if (operacion === 2) {
      if (!validarCampos()) return;
    }

    const datosConstante = {
      codcons: props.datos?.codcons,
      codint: props.codIntegrante,
      valor: parseFloat(txtValor.current?.value.replace(/\./g, '').replace(',', '.') || '0'),
      operacion: operacion
    };

    if (props.onAceptar) {
      props.onAceptar(datosConstante);
    }

    props.onHide();
  };

  const cancelar = () => {
    props.onHide();
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="header-azulGradiant">
        <h3>
          {operacion === 2 && "Editar Valor de Constante"}
          {operacion === 4 && "Consultar Valor de Constante"}
        </h3>
        <a type="button" onClick={cancelar}>
          salir <i className="fa fa-times"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        {Object.keys(errores).length > 0 && (
          <div className="alert alert-danger col-12" role="alert">
            {Object.values(errores).map((error, index) => (
              <div key={index}>• {error}</div>
            ))}
          </div>
        )}

        <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex flex-wrap">
          <legend className="float-none m-0 w-auto">Valor de la Constante</legend>
          
          <div className="col-md-12 px-0 mx-auto row">
            <div className="input-group input-group-sm mb-1 col-md-4 px-0">
              <span className="input-group-text">Cod. Constante:</span>
              <input
                type="text"
                className="form-control text-center"
                value={props.datos?.codcons || ''}
                disabled={true}
              />
            </div>

            <div className="input-group input-group-sm mb-1 col-md-8 px-0">
              <span className="input-group-text">Nombre:</span>
              <input
                type="text"
                className="form-control"
                value={props.datos?.nomcons || ''}
                disabled={true}
              />
            </div>
            <div className="input-group input-group-sm mb-1 col-md-8"></div>

            <div className="input-group input-group-sm mb-1 col-md-4 px-0">
              <span className="input-group-text">Valor:</span>
              <input
                type="text"
                className="form-control text-end"
                ref={txtValor}
                disabled={operacion === 4}
                onFocus={(e) => e.target.select()}
                onBlur={(e) => {
                  if (e.target.value) {
                    const valor = e.target.value.replace(/[^\d,.]/g, '');
                    if (valor) {
                      const num = parseFloat(valor.replace(/\./g, '').replace(',', '.'));
                      if (!isNaN(num)) {
                        e.target.value = num.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                      }
                    } else {
                      e.target.value = "0,00";
                    }
                  } else {
                    e.target.value = "0,00";
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    aceptar();
                  }
                }}
              />
            </div>

      
          </div>
        </fieldset>
      </Modal.Body>
      <Modal.Footer className="footer-azulGradiant">
        {operacion === 2 && (
          <button
            type="button"
            className="btn btn-sm rounded-pill col-md-2 btn-success"
            onClick={aceptar}
          >
            Aceptar
          </button>
        )}
        <button
          type="button"
          onClick={cancelar}
          className="btn btn-sm rounded-pill col-md-2 btn-danger"
        >
          Cancelar
        </button>
      </Modal.Footer>
    </Modal>
  );
};